import { graphql } from 'src/gql';

export const ClientPortalDeleteAccountMutation = graphql(`
  mutation ClientPortalDeleteAccount($input: DeleteAccountInput!) {
    deleteAccount(input: $input) {
      success
    }
  }
`);

export const ClientPortalDeleteAssetMutation = graphql(`
  mutation ClientPortalDeleteAsset($input: DeleteAssetInput!) {
    deleteAsset(input: $input) {
      success
    }
  }
`);

export const ClientPortalDeleteLiabilityMutation = graphql(`
  mutation ClientPortalDeleteLiability($input: DeleteLiabilityInput!) {
    deleteLiability(input: $input) {
      success
    }
  }
`);

export const ClientPortalUpdateAccountNetWorthMutation = graphql(`
  mutation ClientPortalUpdateAccountNetWorth($input: UpdateAccountInput!) {
    updateAccount(input: $input) {
      account {
        id
        hiddenFromNetWorth
      }
    }
  }
`);

export const ClientPortalUpdateAssetNetWorthMutation = graphql(`
  mutation ClientPortalUpdateAssetNetWorth($input: UpdateAssetInput!) {
    updateAsset(input: $input) {
      asset {
        id
        hiddenFromNetWorth
      }
    }
  }
`);

export const ClientPortalUpdateLiabilityNetWorthMutation = graphql(`
  mutation ClientPortalUpdateLiabilityNetWorth($input: UpdateLiabilityInput!) {
    updateLiability(input: $input) {
      liability {
        id
        hiddenFromNetWorth
      }
    }
  }
`);

export const ClientPortalUpdateAccountBalanceMutation = graphql(`
  mutation ClientPortalUpdateAccountBalance($input: UpdateAccountInput!) {
    updateAccount(input: $input) {
      account {
        id
        lastUpdatedAt
        displayBalance {
          amount
        }
      }
    }
  }
`);

export const ClientPortalUpdateAccountCustomNameMutation = graphql(`
  mutation ClientPortalUpdateAccountCustomName($input: UpdateAccountInput!) {
    updateAccount(input: $input) {
      account {
        id
        customName
      }
    }
  }
`);
